import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core'
import { FlexModule } from '@angular/flex-layout'
import { ControlValueAccessor, FormBuilder, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms'
import { MatDividerModule } from '@angular/material/divider'
import { MatExpansionModule } from '@angular/material/expansion'
import { PortalModel, PortalQuestion } from '@mmx/shared'
import { TranslateModule } from '@ngx-translate/core'
import { BehaviorSubject, Subject, takeUntil } from 'rxjs'

import { AuthAttachmentsComponent } from '../auth-attachments'
import { AuthPortalQuestionsFormComponent } from '../auth-portal-questions-form'

@Component({
  selector: 'mmx-auth-clinical-information',
  templateUrl: './auth-clinical-information.component.html',
  styleUrls: ['./auth-clinical-information.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatExpansionModule,
    MatDividerModule,
    TranslateModule,
    FlexModule,
    AuthPortalQuestionsFormComponent,
    AuthAttachmentsComponent,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: AuthClinicalInformationComponent,
      multi: true,
    },
  ],
})
export class AuthClinicalInformationComponent implements OnInit, OnChanges, OnDestroy, ControlValueAccessor {
  @Input()
  public authDetailsValid = false

  @Input()
  public procedureCodes: string[] = []

  @Input()
  public diagnosisCodes: string[] = []

  @Input()
  public attachments: any

  @Input()
  public attachmentsLoading = false

  @Input()
  public availablePortals: PortalModel[] = []

  @Input()
  public questions: PortalQuestion[] = []

  @Output()
  public newAttachmentsAdded = new EventEmitter<void>()

  @Output()
  public pendingAttachments = new EventEmitter<void>()

  public statusText$ = new BehaviorSubject<string>('')
  public submitBtnDisabled = false

  public formGroup = this.fb.group({
    id: this.fb.control<string>(null),
    questions: this.fb.control({}),
    files: this.fb.control<{ file: File, documentType: string }[]>([]),
  })

  private onDestroy$ = new Subject<void>()
  private onChange: any = () => { }
  private onTouch: any = () => { }

  private changes$ = new Subject<void>()

  constructor(
    private fb: FormBuilder,
  ) { }

  public ngOnInit() {
    this.formGroup.valueChanges
      .pipe(
        takeUntil(this.onDestroy$),
      )
      .subscribe((value) => {
        this.onChange(value)
        this.onTouch()
      })
  }

  public ngOnChanges() {
    this.changes$.next()
  }

  public ngOnDestroy() {
    this.onDestroy$.next()
    this.onDestroy$.complete()
  }

  public writeValue(value: any) {
    this.formGroup.patchValue(value || {})
  }

  public registerOnChange(fn: any) {
    this.onChange = fn
  }

  public registerOnTouched(fn: any) {
    this.onTouch = fn
  }
}
